import React from 'react';
import { ComponentWithAs, forwardRef, Icon, IconProps } from '@chakra-ui/react';

const Plate: ComponentWithAs<'svg', IconProps> = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon viewBox='0 0 260 80' ref={ref} {...props}>
    <g filter='url(#filter0_i)'>
      <ellipse cx='130' cy='39.5' rx='130' ry='39.5' fill='#6D9775' />
    </g>
    <g filter='url(#filter1_d)'>
      <ellipse cx='130' cy='39.5' rx='100' ry='25.5' fill='#80A988' />
    </g>
    <defs>
      <filter
        id='filter0_i'
        x='0'
        y='-4'
        width='260'
        height='83'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'
      >
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dy='-4' />
        <feGaussianBlur stdDeviation='2' />
        <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
        <feColorMatrix
          type='matrix'
          values='0 0 0 0 0.0627451 0 0 0 0 0.278431 0 0 0 0 0.188235 0 0 0 0.3 0'
        />
        <feBlend mode='normal' in2='shape' result='effect1_innerShadow' />
      </filter>
      <filter
        id='filter1_d'
        x='26'
        y='6'
        width='208'
        height='59'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'
      >
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dy='-4' />
        <feGaussianBlur stdDeviation='2' />
        <feComposite in2='hardAlpha' operator='out' />
        <feColorMatrix
          type='matrix'
          values='0 0 0 0 0.0627451 0 0 0 0 0.278431 0 0 0 0 0.188235 0 0 0 0.3 0'
        />
        <feBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow' />
        <feBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow' result='shape' />
      </filter>
    </defs>
  </Icon>
));

export default Plate;
